var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm.loading && !_vm.accountMailboxes.length
        ? _c("gg-loading", {
            attrs: {
              loading: true,
              type: "card"
            }
          })
        : !_vm.loadFailed && !_vm.accountMailboxes.length
        ? _c("feature-setup", {
            attrs: {
              feature: "accounts"
            },
            on: {
              create: function create($event) {
                return _vm.$emit("create-mailbox")
              }
            }
          })
        : _c(
            "gg-card",
            {
              attrs: {
                flat: ""
              }
            },
            [
              _c("gg-card-header", [
                _c(
                  "div",
                  {
                    staticClass: "d-flex align-center flex-wrap"
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "mr-auto"
                      },
                      [_vm._v("Manage Mailboxes")]
                    ),
                    _c(
                      "gg-btn",
                      {
                        staticClass: "my-1",
                        attrs: {
                          secondary: "",
                          small: ""
                        },
                        on: {
                          click: function click($event) {
                            return _vm.$emit("create-mailbox")
                          }
                        }
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            attrs: {
                              left: "",
                              small: ""
                            }
                          },
                          [_vm._v("mdi-plus")]
                        ),
                        _vm._v("Add Mailbox ")
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c(
                "gg-card-text",
                [
                  _vm.loadFailed
                    ? _c(
                        "v-alert",
                        {
                          staticClass: "mb-4",
                          attrs: {
                            type: "error",
                            text: "",
                            dense: ""
                          }
                        },
                        [
                          _vm._v(
                            " We couldn't load the mailboxes on this account. "
                          ),
                          _c(
                            "gg-btn",
                            {
                              staticClass: "ml-2",
                              attrs: {
                                small: "",
                                tertiary: ""
                              },
                              on: {
                                click: _vm.load
                              }
                            },
                            [_vm._v("Try again")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("mailboxes-table", {
                    attrs: {
                      items: _vm.accountMailboxes,
                      loading: _vm.loading
                    },
                    on: {
                      action: _vm.handleAction
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
      _c(
        "v-dialog",
        {
          attrs: {
            "hide-overlay": "",
            "max-width": "500px"
          },
          model: {
            value: _vm.modals.password,
            callback: function callback($$v) {
              _vm.$set(_vm.modals, "password", $$v)
            },
            expression: "modals.password"
          }
        },
        [
          _vm.modals.password && _vm.selected
            ? _c("change-password", {
                attrs: {
                  email: _vm.selected.email,
                  domain: _vm.selected.domain
                },
                on: {
                  close: function close($event) {
                    return _vm.closeModal("password")
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm.current
        ? [
            _c("mailbox-settings-modal", {
              attrs: {
                "is-active": _vm.modals.settings,
                mailbox: _vm.current
              },
              on: {
                changed: function changed($event) {
                  return _vm.refreshService(_vm.service.id)
                },
                close: function close($event) {
                  _vm.modals.settings = false
                }
              }
            }),
            _c("create-forwarder-modal", {
              attrs: {
                "is-active": _vm.modals.forwarder,
                mailbox: _vm.current
              },
              on: {
                close: function close($event) {
                  _vm.modals.forwarder = false
                }
              }
            }),
            _c("add-alias-modal", {
              attrs: {
                "is-active": _vm.modals.alias,
                mailbox: _vm.current
              },
              on: {
                created: function created($event) {
                  return _vm.refreshService(_vm.service.id)
                },
                close: function close($event) {
                  _vm.modals.alias = false
                }
              }
            }),
            _c("auto-reply-modal", {
              attrs: {
                "is-active": _vm.modals.autoreply,
                mailbox: _vm.current
              },
              on: {
                close: function close($event) {
                  _vm.modals.autoreply = false
                }
              }
            }),
            _c("catch-all-modal", {
              attrs: {
                "is-active": _vm.modals.catchall,
                mailbox: _vm.current
              },
              on: {
                close: function close($event) {
                  _vm.modals.catchall = false
                }
              }
            })
          ]
        : _vm._e(),
      _vm.selected
        ? _c("delete-email", {
            attrs: {
              "is-active": _vm.modals.remove,
              email: _vm.selected.email
            },
            on: {
              close: function close($event) {
                return _vm.closeModal("remove")
              }
            }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }